import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import AuthorizeApp from "./AuthorizeApp"

ReactDOM.render(
  <React.StrictMode>
    <AuthorizeApp>
      <App />
    </AuthorizeApp>
  </React.StrictMode>,
  document.getElementById("root")
);
